export default {
      id: "Icon--retry-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--retry",
      toString: function () {
        return this.url;
      }
    }